export default __webpack_public_path__ + "static/media/yt-logo.e663625f.png";